module.exports = {
  apiHost: "https://api.herveybay.sensoreal.com.au",
  assetsHost: "https://assets.herveybay.sensoreal.com.au",
  contact: {
    address: "",
    email: "",
    phone: "",
    website: "",
  },
  formTemplate: "default",
  header: {
    logo: "",
    text: {
      en: "Your Herveybay Selections",
      ar: "",
    },
    color: "#fff",
  },
  langs: [{ code: "en", dir: "ltr" }],
  links: {
    instagram: "",
    facebook: "",
    linkedin: "",
    privacy: "",
    twitter: "",
    youtube: "",
  },
  style: {
    primaryColor: "#2f4b5b",
    textColor: "#fff",
  },
};
